import React from 'react';

export interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number;
  max?: number;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  indicatorClassName?: string;
}

export const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className = '', indicatorClassName = '', value = 0, max = 100, size = 'md', ...props }, ref) => {
    const safeMax = max > 0 ? max : 100;
    const percentage = Math.min(100, Math.max(0, (value / safeMax) * 100));

    const sizes = {
      xs: 'h-1.5',
      sm: 'h-2',
      md: 'h-3',
      lg: 'h-4',
    };

    return (
      <div
        ref={ref}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={safeMax}
        aria-valuenow={Math.min(safeMax, Math.max(0, value))}
        className={`w-full overflow-hidden rounded-full bg-slate-100 ${sizes[size]} ${className}`}
        {...props}
      >
        <div
          className={`h-full rounded-full bg-os-primary transition-all duration-300 ${indicatorClassName}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    );
  }
);

Progress.displayName = 'Progress';
